var exports = {
  "VN": "xaf9ae18d--7d81b9--close",
  "Qs": "xaf9ae18d--7d81b9--content",
  "_8": "xaf9ae18d--7d81b9--img",
  "nf": "xaf9ae18d--7d81b9--link",
};

module.exports = exports;
